<template>
  <section class="closefriend-hero h-100">
    <b @click="slideBar()" :class="showSlideBar ? 'screen-overlay show' : 'screen-overlay'"></b>
    <InfluencerMenu @menuClicked="slideBar()" :show-slide-bar="showSlideBar" />
    <header-menu @slideMenu="slideBar()" :is-loading="isLoading"></header-menu>

    <div class="container-fluid mt-3">
      <div class="row justify-content-center">
        <div class="col-12 px-2 px-md-4" style="max-width: 1200px;">
          <!-- Header with Add Content Button -->
          <div class="d-flex flex-wrap align-items-center justify-content-between mb-4 mt-2 px-1 gap-2">
            <div>
              <h5 class="text-white font-weight-700 mb-0 font-size-20">Creator Dashboard</h5>
              <span class="text-muted font-size-12">{{ stats.activeFriend !== null ? stats.activeFriend : 0 }} active subscribers</span>
            </div>
            <button type="button" class="cp-btn-primary d-inline-flex align-items-center" @click="$router.push({name: 'BonusContentAdd'})">
              <i class="fa fa-plus me-2 font-size-12"></i> Add Content
            </button>
          </div>

          <!-- Top Tab Navigation -->
          <div class="d-flex flex-wrap align-items-center mb-4 mt-2">
            <span class="badge filter-pill cursor-pointer me-2 mb-2" 
              :class="activeTab === 'stats' ? 'active' : ''"
              @click="activeTab = 'stats'">
              <i class="fa fa-chart-bar me-1"></i> Stats
            </span>
            <span class="badge filter-pill cursor-pointer me-2 mb-2" 
              :class="activeTab === NEED_TO_ADD ? 'active' : ''"
              @click="activeTab = NEED_TO_ADD; filterSubscribers(NEED_TO_ADD)">
              <i class="fa fa-user-plus me-1"></i> To Add
            </span>
            <span class="badge filter-pill cursor-pointer me-2 mb-2" 
              :class="activeTab === NEED_TO_REMOVE ? 'active' : ''"
              @click="activeTab = NEED_TO_REMOVE; filterSubscribers(NEED_TO_REMOVE)">
              <i class="fa fa-user-minus me-1"></i> To Remove
            </span>
            <span class="badge filter-pill cursor-pointer me-2 mb-2" 
              :class="activeTab === ACTIVE ? 'active' : ''"
              @click="activeTab = ACTIVE; filterSubscribers(ACTIVE)">
              <i class="fa fa-users me-1"></i> Active
            </span>
            <span class="badge filter-pill cursor-pointer me-2 mb-2" 
              :class="activeTab === INACTIVE ? 'active' : ''"
              @click="activeTab = INACTIVE; filterSubscribers(INACTIVE)">
              <i class="fa fa-user-slash me-1"></i> Inactive
            </span>
          </div>

          <template v-if="activeTab === 'stats'">
            <div class="login-card mx-auto mb-3 p-3 p-md-4">
              <h6 class="text-white font-weight-500 mb-4">
                <i class="fa fa-chart-line me-2" style="color: #80CBFE;"></i>Creator Stats
              </h6>
              <div class="row">
                
                <!-- Active Subscribers -->
                <div class="col-6 col-md-3 mb-3 mb-md-0">
                  <div class="d-flex flex-column h-100 position-relative px-2">
                    <p class="text-muted font-size-12 text-uppercase letter-spacing-1 mb-2">Active Subscribers</p>
                    <div class="d-flex align-items-baseline mb-2">
                      <span class="revenue-amount me-2" style="font-size: 32px; font-weight: 700; color: #fff;">{{ stats.activeFriend !== null ? stats.activeFriend : '...' }}</span>
                    </div>
                    <!-- Divider for desktop -->
                    <div class="d-none d-md-block position-absolute" style="right: 0; top: 10%; height: 80%; width: 1px; background: rgba(255,255,255,0.1);"></div>
                  </div>
                </div>

                <!-- Monthly Revenue -->
                <div class="col-6 col-md-3 mb-3 mb-md-0">
                  <div class="d-flex flex-column h-100 position-relative px-2">
                    <p class="text-muted font-size-12 text-uppercase letter-spacing-1 mb-2">Monthly Revenue</p>
                    <div class="d-flex align-items-baseline mb-2">
                      <span class="revenue-amount me-2" style="font-size: 32px; font-weight: 700; color: #fff;">{{ stats.currentMonthlyRevenue !== null ? '$' + stats.currentMonthlyRevenue : '...' }}</span>
                    </div>
                    <!-- Divider for desktop -->
                    <div class="d-none d-md-block position-absolute" style="right: 0; top: 10%; height: 80%; width: 1px; background: rgba(255,255,255,0.1);"></div>
                  </div>
                </div>

                <!-- Annualized Revenue -->
                <div class="col-6 col-md-3 mb-3 mb-md-0">
                  <div class="d-flex flex-column h-100 position-relative px-2">
                    <p class="text-muted font-size-12 text-uppercase letter-spacing-1 mb-2">Annualized Revenue</p>
                    <div class="d-flex align-items-baseline mb-2">
                      <span class="revenue-amount me-2" style="font-size: 32px; font-weight: 700; color: #fff;">{{ stats.currentAnnualRevenue !== null ? '$' + stats.currentAnnualRevenue : '...' }}</span>
                    </div>
                    <!-- Divider for desktop -->
                    <div class="d-none d-md-block position-absolute" style="right: 0; top: 10%; height: 80%; width: 1px; background: rgba(255,255,255,0.1);"></div>
                  </div>
                </div>

                <!-- One-time Revenue / Bonus Content -->
                <div class="col-6 col-md-3 mb-3 mb-md-0">
                  <div class="d-flex flex-column h-100 position-relative px-2">
                    <p class="text-muted font-size-12 text-uppercase letter-spacing-1 mb-2">One-time Revenue</p>
                    <div class="d-flex align-items-baseline mb-2" v-if="stats.bonusContentRevenue !== null && stats.bonusContentRevenue > 0">
                      <span class="revenue-amount me-2" style="font-size: 32px; font-weight: 700; color: #fff;">${{ stats.bonusContentRevenue }}</span>
                    </div>
                    <div v-else-if="stats.bonusContentRevenue !== null" class="mt-1">
                      <button @click="$router.replace({name: 'BonusContentAdd'})"
                        class="btn stella-btn py-1 px-3 gradient-a border-radius-12 d-flex align-items-center">
                        <span class="font-size-12 font-weight-600 text-white me-2">Add Bonus Content</span>
                        <img width="14" src="@/assets/images/stella/Create.png">
                      </button>
                    </div>
                    <div class="d-flex align-items-baseline mb-2" v-else>
                      <span class="revenue-amount me-2" style="font-size: 32px; font-weight: 700; color: #fff; opacity: 0.3;">...</span>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </template>

          <template v-else>
            <div class="login-card mx-auto mb-3 p-3 p-md-4">
              <div class="form-block p-0">
                <global-message></global-message>

                <div class="d-flex flex-column flex-sm-row justify-content-between align-items-sm-center mb-3">
                  <h6 class="text-white font-weight-600 mb-2 mb-sm-0 font-size-16">
                    <span v-if="activeTab === NEED_TO_ADD">Subscribers to Add</span>
                    <span v-else-if="activeTab === NEED_TO_REMOVE">Subscribers to Remove</span>
                    <span v-else-if="activeTab === ACTIVE">Active Subscribers</span>
                    <span v-else-if="activeTab === INACTIVE">Inactive Subscribers</span>
                  </h6>
                  <div class="position-relative dashboard-search-container">
                    <i class="fa fa-search position-absolute dashboard-search-icon" @click="search()"></i>
                    <input placeholder="Search Username..." type="text" name="search" v-model="searchTerm" autocomplete="off"
                      @keyup.enter="search()" @input="onSearchInput" class="form-control dashboard-search-input">
                    <span v-if="searchTerm" class="position-absolute cursor-pointer dashboard-search-clear" @click="clearSearch">&times;</span>
                  </div>
                </div>

                          <div class="row align-items-center mt-3 mb-2 mx-0 w-100" v-if="customerSubscriptions.length > 0 && filter !== ''" style="min-height: 38px;">
                            <div class="col-12 col-md-4 d-flex align-items-center px-2 px-md-3">
                              <div class="me-3 flex-shrink-0">
                                <div class="custom-checkbox custom-control dashboard-checkbox m-0">
                                  <input type="checkbox" id="selectAllCheckbox" class="custom-control-input" v-model="selectAll">
                                  <label for="selectAllCheckbox" class="custom-control-label" style="color: white; min-height: 20px;">&nbsp;</label>
                                </div>
                              </div>
                              <label for="selectAllCheckbox" class="text-white font-size-14 font-weight-500 mb-0" style="cursor: pointer;">Select All</label>
                            </div>
                            
                            <div class="col-12 col-md-8 d-flex align-items-center justify-content-start justify-content-md-end px-2 px-md-3 mt-2 mt-md-0">
                              <!-- Global Actions Inline -->
                              <div v-if="showActionSection" class="d-flex align-items-center">
                                <button id="add_btn" v-if="showAction(NEED_TO_ADD)" @click="confirmSave()"
                                  class="btn stella-btn gradient-a rounded-pill font-weight-500 px-4 py-1 me-2">
                                  <span class="text-white font-size-14 font-weight-600">Add</span>
                                </button>
                                <button id="remove_btn" v-if="showAction(NEED_TO_REMOVE)" @click="confirmSave()"
                                  class="btn stella-btn gradient-a rounded-pill font-weight-500 px-4 py-1">
                                  <span class="text-white font-size-14 font-weight-600">Remove</span>
                                </button>
                              </div>
                            </div>
                          </div>

                          <div class="mt-2">

                            <div v-if="customerSubscriptions.length === 0" class="text-center py-5">
                              <p class="text-white font-size-16 mb-0" style="opacity: 0.5;">No subscribers found</p>
                            </div>

                            <div v-else class="msg-inbox-row row align-items-center mb-2 mx-0 w-100" v-for="(customerSubscription, index) in customerSubscriptions" :key="index"
                              :id="customerSubscription.status" style="border-radius: 8px;">
                              
                              <div class="col-12 col-md-4 d-flex align-items-center mb-2 mb-md-0 px-2 px-md-3">
                                <div class="me-3 flex-shrink-0" v-if="filter !== ''">
                                  <div class="custom-checkbox custom-control dashboard-checkbox m-0">
                                    <input type="checkbox" data-checkboxes="mygroup" class="custom-control-input"
                                      :id="`checkbox-${index}`" v-model="selectedItems" :value="index">
                                    <label :for="`checkbox-${index}`" class="custom-control-label"
                                      style="color: white; min-height: 20px;">&nbsp;</label>
                                  </div>
                                </div>

                                <div class="d-flex align-items-center" style="min-width: 0;">
                                  <span data-toggle="popover" :title="customerSubscription.handle" :id="`IG-${index}`" class="text-white font-size-14 font-weight-500 text-truncate me-2"
                                    data-content="Copied" @click="showCopiedPopover(`IG-${index}`)">
                                    {{ customerSubscription.handle }}
                                  </span>
                                  <img v-if="customerSubscription.invalidHandle"
                                    class="dashboard-action-img question-mark flex-shrink-0" src="@/assets/images/stella/flagged.png"
                                    @click="confirmFlagChange(customerSubscription)">
                                  <img v-else class="dashboard-action-img question-mark flex-shrink-0"
                                    src="@/assets/images/stella/flagged-white.png"
                                    @click="confirmFlagChange(customerSubscription)">
                                </div>
                              </div>

                              <div class="col-5 col-md-2 d-flex align-items-center px-2 px-md-3">
                                <span class="badge rounded-pill font-weight-normal px-3 py-1"
                                  :class="getPlatformColor(customerSubscription)">
                                  {{ customerSubscription.platform }}
                                </span>
                              </div>

                              <div class="col-7 col-md-3 d-flex align-items-center px-2 px-md-3">
                                <span class="text-muted font-size-12 flex-shrink-0">
                                  <span style="opacity: 0.7;" class="me-1">Added:</span>{{ customerSubscription.friendSince | formatDate }}
                                </span>
                              </div>

                              <div class="col-12 col-md-3 d-flex align-items-center justify-content-start justify-content-md-end mt-2 mt-md-0 px-2 px-md-3">
                                <!-- Message -->
                                <div class="action-icon-btn me-2" title="Message" @click="openMessageModal(customerSubscription)">
                                  <img class="dashboard-action-img" src="@/assets/images/stella/custom-req.png">
                                </div>
                                <!-- Add -->
                                <div class="action-icon-btn me-2" title="Add" v-if="isAddOrRemove(customerSubscription)" @click="confirmSingleSave(customerSubscription, true)">
                                  <img class="dashboard-action-img" src="@/assets/images/stella/plus.png">
                                </div>
                                <!-- Remove -->
                                <div class="action-icon-btn me-2" title="Remove" v-else @click="confirmSingleSave(customerSubscription, false)">
                                  <img class="dashboard-action-img" src="@/assets/images/stella/close.png">
                                </div>
                                <!-- Block -->
                                <div class="action-icon-btn" title="Block" @click="confirmSingleSave(customerSubscription, BLOCKED)">
                                  <img class="dashboard-action-img" src="@/assets/images/stella/block.png">
                                </div>
                              </div>

                            </div>
                          </div>
              </div>
            </div>
          </template>

          <infinite-loading ref="infiniteLoading" @infinite="loadMobileSubscriptions">
            <div slot="no-more"></div>
            <div slot="no-results"></div>
          </infinite-loading>

          <model ref="model" @confirm="nowSave()" @cancel="" />
          <model-direct-message ref="directMessage" />

          <model-basic ref="modelFlag" title="Can't find this user?"
            text="Flag it and we will reach out to the user to see if we can get the corrected username"
            button-color="text-dark btn-danger" confirm-btn-txt="Flag" @confirm="saveFlagChange()" />

            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

import {mapActions, mapGetters} from 'vuex'

import {Dropdown, DropdownItem, DropdownMenu} from 'element-ui';
import {httpMixin} from "@/mixin/http-mixin";
import {geDecodedToken} from "@/common/http-common";
import {ACCESS_TOKEN, PLATFORM_SNAPCHAT, PLATFORM_TELEGRAM, PLATFORM_TIKTOK} from "@/properties/close-friend";
import InfluencerMenu from "@/components/module/influencer/shared/InfluencerMenu";
import InfluencerHeader from "@/components/module/influencer/shared/InfluencerHeader";
import HeaderMenu from "@/components/module/influencer/shared/HeaderMenu";
import GlobalMessage from "@/components/module/shared/GlobalMessage";
import Model from "@/components/module/shared/Model";
import {copy} from '@/common/Utils';
import {constructCustomerURL} from "@/common/baseURL-service";
import ModelBasic from "@/components/module/shared/ModelBasic";
import {SERVICE_CONTENT, SERVICE_DIRECT_MESSAGE} from "@/properties/micro-service";
import infiniteScroll from "vue-infinite-scroll";
import InfiniteLoading from "vue-infinite-loading";
import titleMixin from "../../../mixin/title-mixin";
import ModelDirectMessage from "@/components/module/shared/ModelDirectMessage";

const NEED_TO_ADD = 'NeedToAdd';
const NEED_TO_REMOVE = 'NeedToRemove';
const ACTIVE = 'Active';
const INACTIVE = 'Inactive';
const DELETED = 'Removed';
const BLOCKED = 'Blocked';

import PremiumUrlBox from "@/components/module/influencer/shared/PremiumUrlBox";
import SleekNotificationCard from "@/components/module/influencer/shared/SleekNotificationCard";
import PwaActionBar from "@/components/module/influencer/shared/PwaActionBar";

export default {
  name: 'CreatorDashboardMobile',
  title: 'Creator dashboard',
  components: {
    Model, GlobalMessage, HeaderMenu,
    InfluencerHeader, InfluencerMenu, ModelBasic, ModelDirectMessage,
    ElDropdown: Dropdown, ElDropdownMenu: DropdownMenu, ElDropdownItem: DropdownItem,
    InfiniteLoading, PremiumUrlBox, SleekNotificationCard, PwaActionBar
  },
  mixins: [httpMixin, titleMixin],

  data() {
    return {
      activeTab: 'stats',
      user: {},
      customerSubscriptions: [],
      customerSubscription: null,
      selectedItems: [],
      searchTerm: '',
      showSlideBar: false,
      filter: NEED_TO_ADD,
      NEED_TO_ADD,
      NEED_TO_REMOVE,
      ACTIVE,
      INACTIVE,
      DELETED,
      pendingCustomRequests: 0,
      messageCount: 0,
      action: false,
      stats: {activeFriend: null, currentMonthlyRevenue: null, currentAnnualRevenue: null, bonusContentRevenue: null},
      copied: false,
      toggled: false,
      subMenu: false,

      pageNumber: 0,
      noOfItems: 11,
      isComplete: false
    }
  },
  directives: {
    infiniteScroll
  },
  created() {
    if (this.$route.params.isSaved) {
      this.setMessage('Saved successfully');
    }
    let redirectTo = null;
    if (this.getRedirectTo()) {
      redirectTo = this.getRedirectTo();
      this.setRedirectTo(null);
    }
    let userId = geDecodedToken(ACCESS_TOKEN).id;
    this.getData(`identity/api/v1/influencers/${userId}`, (data) => {
      this.setUser(data);
      this.user = data;
      if (redirectTo) {
        this.$router.push({name: 'CreatorDirectMessage', params: {customerId: redirectTo.chatMessage}});
      }
    });
    if (!redirectTo) {
      this.getInfluencerStats();
      //Get pending custom request count
      let url = `${SERVICE_CONTENT}/api/v1/influencers/${userId}/custom-request/count`;
      this.getData(url, (count) => {
        this.pendingCustomRequests = count;
      });
      //Get messages not read
      url = `${SERVICE_DIRECT_MESSAGE}/api/v1/chat/chat-messages/influencers/${userId}/unread-count`
      this.getData(url, (count) => {
        this.messageCount = count;
      });
      this.applyTabFromRoute();
    }
  },
  watch: {
    '$route'() {
      this.applyTabFromRoute();
    }
  },
  computed: {
    revenueLabel() {
      if (this.toggled) {
        return 'MONTHLY';
      } else {
        return 'ANNUALIZED';
      }
    },
    revenue() {
      if (this.toggled) {
        return this.stats.currentMonthlyRevenue;
      } else {
        return this.stats.currentAnnualRevenue;
      }
    },
    isNeedToAddExists() {
      let custSub = this.customerSubscriptions.find(custSub => custSub.status === NEED_TO_ADD);
      return !!custSub;
    },
    showActionSection() {
      return (this.showAction(NEED_TO_ADD) || this.showAction(NEED_TO_REMOVE)) && this.selectedItems.length > 0;
    },
    selectAll: {
      get() {
        return this.customerSubscriptions && this.selectedItems.length > 0 ? this.selectedItems.length === this.customerSubscriptions.length : false;
      },
      set(value) {
        if (value) {
          for (let i = 0; i < this.customerSubscriptions.length; i++) {
            if (!this.customerSubscriptions[i].invalidHandle) {
              this.selectedItems.push(i);
            }
          }
        } else {
          this.selectedItems.splice(0);
          console.log(this.selectedItems);
        }
      }
    },
    copyLabel() {
      return this.copied ? 'Copied' : 'Copy';
    }
  },
  methods: {
    ...mapActions(['setUser', 'pushGlobalError', 'setMessage', 'setRedirectTo']),
    ...mapGetters(['getUser', 'getRedirectTo']),

    /**
     * This is used by infinite loading component, which works for mobile
     */
    loadMobileSubscriptions($state) {
      //back up the old value, as it will change once we get new set of subscriptions
      let isSelectedAll = this.selectAll;
      let userId = geDecodedToken(ACCESS_TOKEN).id;
      this.getData(`subscription/api/v1/influencers/${userId}/status/${this.filter}/page?pageNumber=${this.pageNumber}&numberOfItems=${this.noOfItems}`, (page) => {
        if (!page.empty) {
          this.customerSubscriptions.push(...page.content);
          this.scrollToNeedToAddOnce();
          this.selectAllSubscriptions(isSelectedAll);
          $state.loaded();
        }
        if (page.last) {
          $state.complete();
        }
      });
    },
    selectAllSubscriptions(value) {
      if (value) {
        this.selectedItems.splice(0);
        for (let i = 0; i < this.customerSubscriptions.length; i++) {
          if (!this.customerSubscriptions[i].invalidHandle) {
            this.selectedItems.push(i);
          }
        }
      }
    },
    scrollToNeedToAddOnce() {
      //Do it only the first time
      if (this.$route.params.scrollToNewSubscription && this.pageNumber === 0) {
        this.$nextTick(() => {
          this.scroll(NEED_TO_ADD);
        });
      }
      this.pageNumber += 1;
    },
    getPlatformColor(customerSubscription) { //btn-bg-purple
      let platform = customerSubscription.platform;
      if (platform === PLATFORM_TIKTOK) {
        return 'btn-bg-purple';
      } else if (platform === PLATFORM_SNAPCHAT) {
        return 'btn-bg-yellow';
      } else if (platform === PLATFORM_TELEGRAM) {
        return 'btn-bg-blue'
      }
      return 'btn-insta-green';
    },
    constructCustomerURL,
    applyTabFromRoute() {
      const tabParam = (this.$route.params.tab || this.$route.query.tab || '').toLowerCase();
      if (tabParam === 'active') {
        this.activeTab = ACTIVE;
        this.filterSubscribers(ACTIVE);
      } else if (tabParam === 'to_add' || tabParam === 'need_to_add') {
        this.activeTab = NEED_TO_ADD;
        this.filterSubscribers(NEED_TO_ADD);
      } else if (tabParam === 'to_remove' || tabParam === 'need_to_remove') {
        this.activeTab = NEED_TO_REMOVE;
        this.filterSubscribers(NEED_TO_REMOVE);
      } else if (tabParam === 'inactive') {
        this.activeTab = INACTIVE;
        this.filterSubscribers(INACTIVE);
      } else if (tabParam === 'stats') {
        this.activeTab = 'stats';
      }
    },
    toggle() {
      /* $('toggle').button('toggle');*/
      this.toggled = !this.toggled;
    },
    scroll(id) {
      document.getElementById(id).scrollIntoView({
        behavior: "smooth"
      });
    },
    getInfluencerStats() {
      let userId = geDecodedToken(ACCESS_TOKEN).id;
      //Get active subscribers and revenue
      this.getData(`subscription/api/v1/influencers/${userId}/statistics`, (data) => {
        this.stats = data;
      });
    },
    copyNow(urlSuffix) {
      this.copy(urlSuffix);
      this.copied = true;
      setTimeout(() => {
        this.copied = false;
      }, 2000);
    },
    copy,
    getModelTitle(iAdd) {
      if (iAdd) {
        return 'Add?';
      } else if (iAdd === false) {
        return 'Remove?';
      } else {
        return 'Blocked?'
      }
    },
    getModelText(iAdd, insert) {
      if (iAdd) {
        return `Please confirm that ${insert} fans have been added as Close Friend in your Instagram account`;
      } else if (iAdd === false) {
        return `Please confirm that ${insert} fans have been removed as Close Friend in your Instagram account`;
      } else {
        return `Please confirm that ${insert} fans have been blocked as Close Friend in your Instagram account`;
      }

    },
    isAddOrRemove(customerSubscription) {
      let status = customerSubscription.status;
      if (status === NEED_TO_ADD || status === INACTIVE) {
        return true;
      } else if (status === NEED_TO_REMOVE || status === ACTIVE) {
        return false;
      }
    },
    getStatus(customerSubscription) {
      console.log(customerSubscription.status);
      if (customerSubscription.status === NEED_TO_ADD) {
        console.log(customerSubscription.status);
        return 'Need to add';
      } else if (customerSubscription.status === NEED_TO_REMOVE) {
        return 'Need to remove';
      } else {
        return customerSubscription.status;
      }
    },
    showAction(action) {
      return this.filter === action && this.selectedItems.length > 0;
    },
    filterBtnClass(filter) {
      if (this.filter === filter) {
        return 'active';
      } else {
        return '';
      }
    },

    slideBar() {
      this.showSlideBar = !this.showSlideBar;
      console.log('slideBar', this.showSlideBar);
    },
    search() {
      if (!this.searchTerm || this.searchTerm.trim() === '') {
        return;
      }
      this.filter = '';
      let userId = geDecodedToken(ACCESS_TOKEN).id;
      this.searchTerm = this.searchTerm.trim();
      
      this.getData(`subscription/api/v1/influencers/${userId}/status/search?name=${this.searchTerm}`, (data) => {
        this.customerSubscriptions = data;
      });
    },
    clearSearch() {
      this.searchTerm = '';
      this.filterSubscribers(this.activeTab);
    },
    onSearchInput() {
      if (!this.searchTerm || this.searchTerm.trim() === '') {
        this.filterSubscribers(this.activeTab);
      }
    },
    filterSubscribers(filter) {
      this.filter = filter;
      this.selectedItems.splice(0);
      this.customerSubscriptions.splice(0);
      this.customerSubscription = null;
      this.pageNumber = 0;
      this.isComplete = false;
      this.$nextTick(() => {
        if (this.$refs.infiniteLoading) {
          this.$refs.infiniteLoading.stateChanger.reset();
        }
      });

      /*  this.getData(`subscription/api/v1/influencers/${userId}/status/${filter}/page?pageNumber=${this.pageNumber}&numberOfItems=${this.noOfItems}`, (page) => {
          this.customerSubscriptions.push(...page.content);
        });*/
    },
    confirmSave() {
      if (this.selectedItems.length === 0) {
        return;
      }

      let count = this.selectedItems.length;
      let insert = '';
      console.log(this.selectedItems);
      if (count > 1) {
        insert = this.selectedItems.length;
      } else if (count === 1) {
        let customerSubscription = this.findSubscriber(this.selectedItems[0]);
        insert = '@' + (customerSubscription.name ? customerSubscription.name : customerSubscription.email);
      }

      let isAdd = this.filter === NEED_TO_ADD;
      let title = this.getModelTitle(isAdd);
      let text = this.getModelText(isAdd, insert);
      this.$refs.model.show(title, text);
    },

    confirmFlagChange(customerSubscription) {

      this.customerSubscription = customerSubscription;
      if (customerSubscription.invalidHandle) {
        this.saveFlagChange();
      } else {
        this.$refs.modelFlag.show();
      }
    },

    confirmSingleSave(customerSubscription, action) {

      this.customerSubscription = customerSubscription;
      this.action = action;
      console.log(customerSubscription);
      let insert = '@' + (customerSubscription.name ? customerSubscription.name : customerSubscription.email);

      let title = this.getModelTitle(action);
      let text = this.getModelText(action, insert);
      this.$refs.model.show(title, text);
    },

    findSubscriber(selectedItem) {
      return this.customerSubscriptions[selectedItem];
    },
    cancel() {
      console.log(this.selectedItems)
    },
    nowSave() {
      if (this.customerSubscription) {
        this.saveOne()
      } else {
        this.save();
      }
    },
    save() {

      if (this.selectedItems.length === 0) {
        return;
      }
      this.$refs.model.hide();

      let changeStatus = this.filter === NEED_TO_ADD ? ACTIVE : INACTIVE
      for (let selectedItem of this.selectedItems) {
        let customerSubscription = this.findSubscriber(selectedItem);
        customerSubscription.status = changeStatus;
      }

      let userId = geDecodedToken(ACCESS_TOKEN).id;
      let url = `subscription/api/v1/influencers/${userId}/status/`;

      this.patchData(url, this.customerSubscriptions, (data) => {
        // this.customerSubscriptions = data;
        this.afterSave(userId);
      })
    },
    afterSave(userId) {
      let url = `subscription/api/v1/influencers/${userId}/status/${this.filter}`
      this.selectedItems.splice(0);
      this.customerSubscriptions.splice(0);

      this.getData(url, (data) => {
        for (let datum of data) {
          this.customerSubscriptions.push(datum);
        }
        this.setMessage('Saved successfully');
        this.getInfluencerStats();
      });
    },
    saveOne() {

      if (this.action) {
        this.customerSubscription.status = ACTIVE;
      } else if (this.action === false) {
        this.customerSubscription.status = INACTIVE
      } else {
        this.customerSubscription.status = BLOCKED
      }
      this.$refs.model.hide();
      this.patchOne();
    },
    saveFlagChange() {
      this.$refs.modelFlag.hide();
      this.customerSubscription.invalidHandle = !this.customerSubscription.invalidHandle;
      this.patchOne();
    },
    patchOne() {
      let userId = geDecodedToken(ACCESS_TOKEN).id;
      let url = `subscription/api/v1/influencers/${userId}/status/`;

      this.patchData(url, [this.customerSubscription], (data) => {
        this.customerSubscription = null;
        //this.afterSave(userId);
      });
      this.setMessage('Saved successfully');
    },

    showCopiedPopover(id) {
      $('#' + id).popover('show');

      let copyText = document.getElementById(id);
      let textArea = document.createElement("textarea");
      textArea.value = copyText.textContent.trim();
      document.body.appendChild(textArea);
      textArea.select();
      textArea.setSelectionRange(0, 99999);
      document.execCommand("Copy");
      textArea.remove();

      setTimeout(() => {
        $('#' + id).popover('hide');
      }, 2000);
    },
    doIt() {
      console.log('dropdown');
      this.$nextTick(() => {
        // $('.dropdown').dropdown();
        $('[data-toggle="popover"]').dropdown('toggle');
      });
      // $('#some').dropdown('toggle');
    },

    openMessageModal(customerSubscription){
      let name = customerSubscription.name;
      this.$refs.directMessage.show(name, customerSubscription);
    }
  }
}
;
</script>

<style scoped>
button > span {
  margin-left: 7%;
}

.btn-bg-purple {
  background: #FF37EB;
  background-color: #FF37EB;
  color: black;
}

.btn-bg-blue {
  background: #229ED9;
  background-color: #229ED9;
  color: black;
}

.btn-toggle-custom.active {
  background-color: #55EFC4;
}

.btn-toggle-custom {
  margin: 0 10px;
  padding: 0;
  position: relative;
  border: none;
  height: 15px;
  width: 2.5rem;
  border-radius: 1rem;
  color: #6b7381;
  background: #bdc1c8;
}

.btn-toggle-custom.active {
  transition: background-color 0.25s;
}

.example .btn-toggle-custom {
  top: 50%;
  transform: translateY(-50%);
}

.btn-toggle-custom.active:before {
  opacity: 0.5;
}

.btn-toggle-custom:before, .btn-toggle-custom:after {
  color: #6b7381;
}

.btn-toggle-custom:before {
  left: -4rem;
}

.btn-toggle-custom:before, .btn-toggle-custom:after {
  line-height: 1.5rem;
  width: 4rem;
  text-align: center;
  font-weight: 600;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 2px;
  position: absolute;
  bottom: 0;
  transition: opacity 0.25s;
}

.btn-toggle-custom.active > .handle {
  left: 18px;
  transition: left 0.25s;
}

.btn-toggle-custom > .handle {
  position: absolute;
  top: -5px;
  left: -5px;
  width: 1.125rem;
  height: 1.125rem;
  border-radius: 1.125rem;
  background: #fff;
  transition: left 0.25s;
  background: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4gPHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJncmFkIiBncmFkaWVudFVuaXRzPSJvYmplY3RCb3VuZGluZ0JveCIgeDE9IjAuNSIgeTE9IjAuMCIgeDI9IjAuNSIgeTI9IjEuMCI+PHN0b3Agb2Zmc2V0PSIwJSIgc3RvcC1jb2xvcj0iI2ZmZmZmZiIgc3RvcC1vcGFjaXR5PSIwLjAiLz48c3RvcCBvZmZzZXQ9IjEwMCUiIHN0b3AtY29sb3I9IiMwMDAwMDAiIHN0b3Atb3BhY2l0eT0iMC4xIi8+PC9saW5lYXJHcmFkaWVudD48L2RlZnM+PHJlY3QgeD0iMCIgeT0iMCIgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgZmlsbD0idXJsKCNncmFkKSIgLz48L3N2Zz4g) #fff;
  border: 1px solid #ccc;
  cursor: pointer;
  display: inline-block;
  width: 25px;
  height: 25px;
  position: absolute;
  background-size: 100%;
  background-image: -webkit-gradient(linear, 50% 0, 50% 100%, color-stop(0, rgba(255, 255, 255, 0)), color-stop(100%, rgba(0, 0, 0, .1)));
  background-image: -moz-linear-gradient(rgba(255, 255, 255, 0), rgba(0, 0, 0, .1));
  background-image: -webkit-linear-gradient(rgba(255, 255, 255, 0), rgba(0, 0, 0, .1));
  background-image: linear-gradient(rgba(255, 255, 255, 0), rgba(0, 0, 0, .1));
  -moz-box-shadow: 0 0 8px rgba(0, 0, 0, .3);
  -webkit-box-shadow: 0 0 8px rgb(255 255 255 / 30%);
  box-shadow: 0 0 8px rgb(255 255 255 / 30%);
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  border-radius: 50%;
}

.btn-toggle-custom > .handle:after {
  content: "";
  display: block;
  width: 11px;
  height: 11px;
  margin: auto;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4gPHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJncmFkIiBncmFkaWVudFVuaXRzPSJvYmplY3RCb3VuZGluZ0JveCIgeDE9IjAuNSIgeTE9IjAuMCIgeDI9IjAuNSIgeTI9IjEuMCI+PHN0b3Agb2Zmc2V0PSIwJSIgc3RvcC1jb2xvcj0iIzAwMDAwMCIgc3RvcC1vcGFjaXR5PSIwLjEzIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdG9wLWNvbG9yPSIjZmZmZmZmIiBzdG9wLW9wYWNpdHk9IjAuMCIvPjwvbGluZWFyR3JhZGllbnQ+PC9kZWZzPjxyZWN0IHg9IjAiIHk9IjAiIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIGZpbGw9InVybCgjZ3JhZCkiIC8+PC9zdmc+IA==);
  background-size: 100%;
  background-image: -webkit-gradient(linear, 50% 0, 50% 100%, color-stop(0, rgba(0, 0, 0, .13)), color-stop(100%, rgba(255, 255, 255, 0)));
  background-image: -moz-linear-gradient(rgba(0, 0, 0, .13), rgba(255, 255, 255, 0));
  background-image: -webkit-linear-gradient(rgba(0, 0, 0, .13), rgba(255, 255, 255, 0));
  background-image: linear-gradient(rgba(0, 0, 0, .13), rgba(255, 255, 255, 0));
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  border-radius: 50%;
}

.btn-toggle-custom.active:after {
  opacity: 1;
}

.btn-toggle-custom:before, .btn-toggle-custom:after {
  color: #6b7381;
}

.btn-toggle-custom:after {
  right: -4rem;
  opacity: 0.5;
}

.btn-toggle-custom:before, .btn-toggle-custom:after {
  line-height: 1.5rem;
  width: 4rem;
  text-align: center;
  font-weight: 600;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 2px;
  position: absolute;
  bottom: 0;
  transition: opacity 0.25s;
}

img.dashboard-action-img.question-mark {
  width: 15px;
  margin: 0 3px;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: -70px;
  z-index: 1000;
  display: none;
  float: left;
  min-width: 10rem;
  padding: .5rem 0;
  margin: .125rem 0 0;
  font-size: 1rem;
  color: #212529;
  text-align: left;
  list-style: none;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, .15);
  border-radius: .25rem;
}

.add-bonus-btn {
  background-color: #55EFC4;
  border-radius: 7px;
  color: white;
  font-weight: 500;
  font-size: 12px;
  padding: 5px 8px 5px 32px;
  margin-top: 15px;
  font-family: inherit;
}

.add-bonus-btn span img {
  height: 40px;
  text-align: right;
  padding: 0px 0px 0px 15px;
}
.warning-text{
  color: #664d03 !important;
}
.p-cls{
  margin-bottom: 0px !important;
}

.action-icon-btn {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.05);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
}
.action-icon-btn:hover {
  background-color: rgba(255, 255, 255, 0.15);
}
.action-icon-btn img.dashboard-action-img {
  width: 14px;
  height: auto;
  margin: 0;
}

.dashboard-search-container {
  width: 100%;
}

@media (min-width: 576px) {
  .dashboard-search-container {
    width: 250px;
    margin-left: 1rem;
  }
}

.dashboard-search-icon {
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 13px;
  color: rgba(255, 255, 255, 0.45) !important;
  cursor: pointer;
  z-index: 2;
  transition: color 0.2s ease;
}

.dashboard-search-icon:hover {
  color: #ffffff !important;
}

.login-card .form-control.dashboard-search-input,
.dashboard-search-input {
  width: 100% !important;
  height: 42px !important;
  padding-left: 38px !important;
  padding-right: 36px !important;
  padding-top: 8px !important;
  padding-bottom: 8px !important;
  background: rgba(255, 255, 255, 0.06) !important;
  border: 1px solid rgba(255, 255, 255, 0.12) !important;
  border-radius: 20px !important;
  color: #ffffff !important;
  font-size: 13.5px !important;
  transition: all 0.25s ease !important;
  box-shadow: none !important;
}

.login-card .form-control.dashboard-search-input:focus,
.dashboard-search-input:focus {
  background: rgba(255, 255, 255, 0.09) !important;
  border-color: #E53BB9 !important;
  box-shadow: 0 0 12px rgba(229, 59, 185, 0.35) !important;
  color: #ffffff !important;
  outline: none !important;
}

.login-card .form-control.dashboard-search-input::placeholder,
.dashboard-search-input::placeholder {
  color: rgba(255, 255, 255, 0.38) !important;
  font-size: 13px !important;
}

.dashboard-search-clear {
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 18px;
  color: rgba(255, 255, 255, 0.45) !important;
  line-height: 1;
  z-index: 2;
  transition: color 0.2s ease;
}

.dashboard-search-clear:hover {
  color: #ffffff !important;
}
</style>

